import { ProductDetails } from "@/@types"
import { useSearchParams } from 'next/navigation'

type BreadcrumbMap = Record<string, string>

export default function useProductDetails(product: ProductDetails) {
  const searchParams = useSearchParams()
  const industryParam = searchParams.get('industria')

  if (!product) return {
    breadcrumbMap: {},
    info: '',
    videos: [],
    documents: [],
    isIndustryView: false
  }

  const { long_description: info, contents: { videos, files: documents } } = product

  const breadcrumbMap: BreadcrumbMap = {}
  const isIndustryView = !!industryParam

  if (isIndustryView) {
    breadcrumbMap["productos-nuevos"] = "Productos nuevos"

    if (product.industry.length > 0) {
      const selectedIndustry = product.industry.find(industry => industry.slug === industryParam)
        ?? product.industry[0]
      breadcrumbMap[selectedIndustry.slug] = selectedIndustry.name
    }

    if (product.family) {
      breadcrumbMap[product.family.slug] = product.family.name
    }

    if (product.subfamily) {
      breadcrumbMap[product.subfamily.slug] = product.subfamily.name
    }
  } else {
    breadcrumbMap["marcas"] = "Productos por marca"

    if (product.brand) {
      breadcrumbMap[product.brand.slug] = product.brand.name
    }

    if (product.industry.length > 0) {
      const selectedIndustry = product.industry[0]
      breadcrumbMap[selectedIndustry.slug] = selectedIndustry.name
    }

    if (product.family) {
      breadcrumbMap[product.family.slug] = product.family.name
    }

    if (product.subfamily) {
      breadcrumbMap[product.subfamily.slug] = product.subfamily.name
    }
  }

  breadcrumbMap["producto"] = product.slug

  return {
    breadcrumbMap,
    info,
    videos,
    documents,
    isIndustryView
  }
} 